import styled from '@emotion/styled';
import Box from '@mui/material/Box';

const StyledLoadingCircle = styled(Box)``;

export default StyledLoadingCircle;
